/** @format */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
	homefieldIconAvailabilityDotFilled,
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService
} from '@dsg-tech/homefield-angular-icons';
import { HmfSkeletonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'compare-components-skeleton-fulfillment-section',
	imports: [HomefieldIconLibraryModule, HmfSkeletonComponent],
	templateUrl: './skeleton-fulfillment-section.component.html',
	styleUrl: './skeleton-fulfillment-section.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonFulfillmentSectionComponent {
	constructor(private readonly hmfIconService: HomefieldIconsLibraryService) {
		this.hmfIconService.registerIcons([homefieldIconAvailabilityDotFilled]);
	}
}
